const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_dynamicLayout/courses.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { loadMobileCoursesContent, preloadMobilePage } from "@/react/components/Mobile/utils/mobilePageLoaders";
export const Route = createFileRoute("/_protected/_dynamicLayout/courses")({
  loader: preloadMobilePage(loadMobileCoursesContent),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});